import React, { useState } from 'react';

const DatePicker = ({ onDateChange }) => {
  const [dateFrom, setDateFrom] = useState('');
  const [dateTo, setDateTo] = useState('');

  const today = new Date().toISOString().split('T')[0];

  const handleSearch = () => {
    if (onDateChange) {
      onDateChange({ dateFrom, dateTo });
    }
  };

  return (
    <div style={{ 
      display: 'flex', 
      alignItems: 'center', 
      gap: '15px',
      padding: '20px',
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <label style={{ fontWeight: 'bold', color: '#333' }}>Date From:</label>
        <input
          type="date"
          value={dateFrom}
          max={today}
          onChange={(e) => setDateFrom(e.target.value)}
          style={{
            padding: '8px 12px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            fontSize: '14px'
          }}
        />
      </div>
      
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <label style={{ fontWeight: 'bold', color: '#333' }}>Date To:</label>
        <input
          type="date"
          value={dateTo}
          max={today}
          onChange={(e) => setDateTo(e.target.value)}
          style={{
            padding: '8px 12px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            fontSize: '14px'
          }}
        />
      </div>
      
      <button
        onClick={handleSearch}
        className="btn btn-primary"
        style={{
          padding: '8px 20px',
          fontSize: '14px',
          fontWeight: 'bold'
        }}
      >
        Search
      </button>
    </div>
  );
};

export default DatePicker;
